<script setup lang="ts">
import Default from "./layouts/Default.vue";
</script>

<template>
  <Default/>
</template>
